import { createAction, props } from '@ngrx/store';
import { KioskGlobalSettings } from '@core/models/kiosk-global-settings.model';

export const loadKioskGlobalSettings = createAction(
  '[Kiosk Global Settings] Load Kiosk Global Settings',
  props<{ settings: Partial<KioskGlobalSettings> | undefined }>(),
);
